/** Common IANA zones for org alert windows (extend as needed). */
export const ALERT_TIME_ZONE_OPTIONS: ReadonlyArray<{ id: string; label: string }> = [
  { id: 'America/New_York', label: 'Eastern (America/New_York)' },
  { id: 'America/Chicago', label: 'Central (America/Chicago)' },
  { id: 'America/Denver', label: 'Mountain (America/Denver)' },
  { id: 'America/Phoenix', label: 'Arizona (America/Phoenix)' },
  { id: 'America/Los_Angeles', label: 'Pacific (America/Los_Angeles)' },
  { id: 'America/Anchorage', label: 'Alaska (America/Anchorage)' },
  { id: 'Pacific/Honolulu', label: 'Hawaii (Pacific/Honolulu)' },
];
